import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import useAnimation from "../components/useAnimation";

function Contact() {
  const form = useRef();
  const [message, setMessage] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  // email js
  const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY).then(
      (result) => {
        console.log("Email sent successfully ^v^", result.text);
        setMessage("Email sent successfully ^v^"); // notification after clicking send button
        setIsOpen(true);
        form.current.reset(); // clean the form after successfully sending
      },
      (error) => {
        console.log("Email fail to send T^T", error.text);
        setIsOpen(true);
        setMessage("Email fail to send T^T Plz try again"); // notification after clicking send button
      }
    );
  };
  const isAnimating = useAnimation();

  // resume
  // const googleDocLink = process.env.REACT_APP_GOOGLE_DOC_URL;
  const openPDF = () => {
    window.open("/Resume_Yu_Luo.pdf", "_blank");
  };
  return (
    <div className="relative min-h-screen pb-8">
      <div className="fixed inset-0 bg-midBrown -z-10"></div>
      {isAnimating && (
        <div className="fixed inset-0 z-50 bg-pink animate-slideRight"></div>
      )}
      {/* main */}
      <div className="pt-16 md:pt-[4rem] md:pl-[6rem] text-pink  ">
        {/* --------------------------- Contact page title --------------------------- */}
        <div className="mx-2 mb-8 md:mb-24">
          <h1 className="px-2 font-extrabold text-7xl md:text-Rem11 ">
            Thank you.
          </h1>
          <p className="font-semibold text-xl ml-[8%] md:ml-[16%] md:text-6xl ">
            for taking the time to visit my website.
          </p>
        </div>
        {/* --------------------------- content ---------------------------*/}
        <div className="mx-6 md:mx-32">
          {" "}
          <div className="flex flex-col md:flex-row ">
            {/* --------------------------- contact info ---------------------------*/}
            <div className="flex-1 text-beige text-xl md:text-3xl md:mx-[2%] ">
              {/* --------------------------- email --------------------------- */}
              <div className="md:pb-8">
                <p className="font-bold pb-2 text-lightBrown">MY EMAIL </p>
                <a
                  href="mailto:abbieluo.yu@gmail.com"
                  className="hover:underline pl-8 md:pl-[4rem]"
                >
                  abbieluo.yu@gmail.com
                </a>
              </div>
              <div className="flex items-center justify-center py-2 md:hidden">
                <p className="text-xl font-black text-brown">
                  - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                  -
                </p>
              </div>
              {/* --------------------------- other info --------------------------- */}
              <div className="md:pb-1">
                {" "}
                <p className="font-bold pb-2 text-lightBrown">MY OTHER INFO </p>
                <p className="pl-8 md:pl-[4rem]">
                  <a
                    href="http://www.linkedin.com/in/abbieluoyu"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    LinkedIn
                  </a>
                  <span className="px-4">|</span>
                  <a
                    href="https://github.com/abbiekuma"
                    target="_blank"
                    rel="noopener noreferrer"
                    children
                    className="hover:underline"
                  >
                    GitHub
                  </a>
                  <span className="px-4">|</span>

                  <button onClick={openPDF} className="hover:underline">
                    Resume
                  </button>
                </p>
              </div>
              <div className="flex items-center justify-center py-2 md:hidden">
                <p className="font-black text-brown text-xl">
                  - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                  -
                </p>
              </div>
            </div>
            {/*--------------------------- send message ---------------------------*/}
            <div className="flex-1 flex flex-col md:mx-[2%]">
              <h2 className="font-bold text-lightBrown text-xl rounded-xl md:text-3xl">
                {/* bg-darkBrown bg-opacity-50 w-max px-2 */}
                SEND MESSAGE TO ME :)
              </h2>
              <div className="mx-6 md:mx-[6rem]">
                {/* input boxes width */}
                <form
                  className="flex flex-col "
                  ref={form}
                  onSubmit={sendEmail}
                >
                  {/* ---------------------------name & email---------------------------*/}
                  <div className="flex space-x-4">
                    {/* name */}
                    <div className="flex flex-col w-1/3">
                      <label className="font-bold pb-2 text-beige text-lg md:text-2xl">
                        Name
                      </label>
                      <input
                        type="text"
                        name="from_name"
                        className="border-4 bg-darkBrown border-brown rounded-xl p-2 mb-4 text-beige focus:ring focus:ring-pink focus:outline-none md:text-lg"
                        required
                      />
                    </div>
                    {/* --------------------------- email ---------------------------*/}
                    <div className="flex flex-col w-2/3">
                      <label className="font-bold pb-2 text-beige text-lg md:text-2xl">
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        className="border-4 bg-darkBrown border-brown rounded-xl p-2 mb-4 text-beige focus:ring focus:ring-pink focus:outline-none md:text-lg"
                        required
                      />
                    </div>
                  </div>
                  {/* --------------------------- message ---------------------------*/}
                  <label className="font-bold pb-2 text-beige text-lg md:text-2xl">
                    Message
                  </label>
                  <textarea
                    name="message"
                    className="border-4 bg-darkBrown
                border-brown rounded-xl p-2 mb-4 text-beige focus:ring focus:ring-pink focus:outline-none md:text-lg"
                    rows="4"
                    required
                  ></textarea>
                  {/* --------------------------- send button --------------------------- */}
                  <div className="flex justify-center items-center ">
                    <button
                      type="submit"
                      className="bg-lightBrown w-2/3 py-2 rounded-2xl font-black md:text-xl   text-darkBrown hover:bg-darkBrown hover:text-lightBrown  active:bg-pink active:text-darkBrown "
                    >
                      Send
                    </button>
                  </div>
                </form>
                {/* ------------- notification aftering clicking send button -------------*/}
                {isOpen && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 ">
                    <div className="bg-beige p-6 rounded-3xl shadow-lg w-80 text-center border-brown border-8">
                      <p className="text-midBrown text-lg font-semibold">
                        {message}
                      </p>
                      <button
                        onClick={() => setIsOpen(false)}
                        className="text-midBrown font-black font-6xl px-2  bg-lightBrown rounded-2xl border-4 border-midBrown hover:bg-darkBrown hover:border-brown hover:text-lightBrown  active:bg-pink active:text-darkBrown"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Contact;
